import React from 'react'
import styled from 'styled-components'

import useSubmittedProposals from '../../hooks/useSubmittedProposals'
import { downloadZipFile } from './utils/fileDownload'
import { useTranslation } from 'react-i18next'

function getMaterialDownloadUrls(data) {
  if (!Array.isArray(data)) {
    return []
  }
  return data.map(doc => {
    return {
      id: doc.id,
      pseudonym: doc.pseudonym,
      downloadUrl: doc.board.downloadUrl,
      fileName: doc.board.fileName
    }
  })
}

const DownloadBoards = ({ setLoading, setError }) => {
  const { boardsData } = useSubmittedProposals()
  const { t } = useTranslation('proposals')
  const urls = getMaterialDownloadUrls(boardsData)

  const handleDownload = () => {
    downloadZipFile('Boards.zip', urls, setLoading, setError)
  }

  return <Wrapper onClick={handleDownload}>{t('Boards')}</Wrapper>
}

export default DownloadBoards

const Wrapper = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
`
